import highStressImage from '../../../../assets/images/high_stress.png';
import styles from './styles.module.scss';

type Props = {
  isHighStress: boolean;
  guidanceText: string;
};

export const YourCondition: React.FC<Props> = ({ isHighStress, guidanceText }) => (
  <div className={styles.container}>
    <h2 className={styles.sectionTitle}>あなたの状態</h2>
    <div className={styles.content}>
      {isHighStress && (
        <div className={styles.status}>
          <img
            width={36}
            height={36}
            src={highStressImage}
            alt='High stress'
            className={styles.statusIcon}
          />
          <p className={styles.statusText}>あなたはストレスが高い状態です</p>
        </div>
      )}
      <p className={styles.description}>{guidanceText}</p>
    </div>
  </div>
);
